import React, { useEffect, useState } from 'react';
// import './patientList.css'
import {
    Badge,
    Button,
    ButtonGroup,
    Card,
    Container,
    Form,
    Image,
    Modal,
    Stack,
    Table,
} from 'react-bootstrap';
import edit from '../../Assets/Img/edit.png';
import view from '../../Assets/Img/eye.png';
import NoDraft from '../../Assets/Img/noDrafts.png';
import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router';
import LoadingComponent from '../LoadingComponent';
import { Eye, Pencil, Plus, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { frenchFormatDate } from '../../helper';
// import AddOptician from './addOptician';
import DeleteUser from '../Profile/deleteUser';
import { useDoctorListMutation } from './doctorApi';
import AddDoctor from './addDoctor';
import { getSecureItem } from "../../utils/secureStorage";
const DoctorList = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const user = getSecureItem('UserData');
    const [loading, setLoading] = useState(true);
    const [edit, setEdit] = useState({});
    const config = { email: '', mobile: '' };
    const [doctorData, setDoctorData] = useState([]);
    useEffect(() => {
        console.log("doctorData ================>", doctorData)
    }, [doctorData])
    const [doctorList] = useDoctorListMutation();

    useEffect(() => {
        if (loading) {
            (async () => {
                let { data } = await doctorList(config);
                console.log(data, 'datadata');
                setDoctorData(data);
                setLoading(false);
            })();
        }
    }, [loading]);

    // const handleFilterChange = (count = 1) => {
    //     setLoading(true)
    // }

    // const handleChange = (e) => {
    //     console.log(e.target.value, "e.target.value");

    //     setPatientListConfig((prevValues) => {
    //         return {
    //             ...prevValues,
    //             [e.target.name]: e.target.value

    //         }
    //     });
    // }

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <>
            <Container fluid className="list_wrapper">
                <Stack direction="horizontal" gap={3} className="mb-3">
                    <div className="ms-auto">
                        {/* <Button variant='light' onClick={() => { setEditData({}); setShow(true) }}><Plus width={14} height={14} />{t("addPatient")}</Button> */}
                        <AddDoctor
                            setLoading={setLoading}
                            edit={edit}
                            setEdit={setEdit}
                        />
                    </div>
                </Stack>
                <Card>
                    {/* <Card.Header>
                        <Stack direction="horizontal" gap={3} className='listing_filters'>
                            <Stack direction="horizontal" gap={3}>
                                <Form.Control type='text' onChange={handleChange} value={patientListConfig.search} name='search' placeholder={t("search")} />
                                <Form.Control type='date' onChange={handleChange} name='startDate' />
                                <Form.Control type='date' onChange={handleChange} name='endDate' />
                                <Button variant='secondary' onClick={() => handleFilterChange()}>{t("search")}</Button>
                            </Stack>
                            <div className="ms-auto">
                                <Button variant='link' className='' onClick={() => {
                                    setPatientListConfig(config)
                                    setLoading(true)
                                }}>
                                    {t("resetFilters")}
                                </Button>
                            </div>
                        </Stack>
                    </Card.Header> */}
                    <Card.Body className="table_outer">
                        <Table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>{t('ID du médecin')}</th>
                                    <th>{t('name')}</th>
                                    <th>{t('email')}</th>
                                    <th>{t('Type de compte')}</th>
                                    <th>{t('RPPS')}</th>
                                    <th>{t('Docteur Priorité')}</th>
                                    <th>{t('createdOn')}</th>
                                    <th>{t('status')}</th>
                                    <th className="text-center">
                                        {t('actions')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {doctorData.length > 0 ? (
                                    doctorData.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <img
                                                    src={
                                                        item?.profileImagePath ||
                                                        '/avatar-s-11.jpg'
                                                    }
                                                    alt="profile image"
                                                    style={{
                                                        height: '1.6rem',
                                                        width: '1.6rem',
                                                        borderRadius: '100%',
                                                        outline:
                                                            '1px solid #e9e9e9',
                                                        outlineOffset: '0.2rem',
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                {item?.doctorIdOfRegistration}
                                            </td>
                                            <td>
                                                {item?.name} {item?.lastName}
                                            </td>
                                            <td>{item.email}</td>
                                            <td>
                                                {item.isExternalDoctor == true
                                                    ? 'Sym IA'
                                                    : 'Téléexpertise'}
                                            </td>
                                            <td>{item.doctorRppsNumber}</td>
                                            <td>{item.doctorPriority}</td>
                                            <td>
                                                {frenchFormatDate(
                                                    item.createdDate
                                                )}
                                            </td>
                                            <td>
                                                {item.isDoctorAvailable ==
                                                true ? (
                                                    <Badge className="status_badge text-primary">
                                                        Active
                                                    </Badge>
                                                ) : (
                                                    <Badge className="status_badge text-danger">
                                                        Inactive
                                                    </Badge>
                                                )}
                                            </td>
                                            <td>
                                                <Stack
                                                    direction="horizontal"
                                                    gap={1}
                                                >
                                                    <div className="m-auto">
                                                        <ButtonGroup>
                                                            <Button
                                                                variant="light"
                                                                onClick={() =>
                                                                    navigate(
                                                                        '/doctor/view',
                                                                        {
                                                                            state: {
                                                                                userData:
                                                                                    item,
                                                                            },
                                                                        }
                                                                    )
                                                                }
                                                            >
                                                                <Stack
                                                                    direction="horizontal"
                                                                    gap={1}
                                                                >
                                                                    <Eye
                                                                        width={
                                                                            16
                                                                        }
                                                                    />
                                                                </Stack>
                                                            </Button>
                                                            {['ADMIN'].includes(
                                                                user?.userType
                                                            ) && (
                                                                <>
                                                                    <Button
                                                                        variant="light"
                                                                        onClick={() =>
                                                                            setEdit(
                                                                                item
                                                                            )
                                                                        }
                                                                    >
                                                                        <Stack
                                                                            direction="horizontal"
                                                                            gap={
                                                                                1
                                                                            }
                                                                        >
                                                                            <Pencil
                                                                                width={
                                                                                    16
                                                                                }
                                                                            />
                                                                        </Stack>
                                                                    </Button>
                                                                    <DeleteUser
                                                                        email={
                                                                            item.email
                                                                        }
                                                                        setLoading={
                                                                            setLoading
                                                                        }
                                                                    />
                                                                </>
                                                            )}
                                                        </ButtonGroup>
                                                    </div>
                                                </Stack>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={6}>
                                            <Stack
                                                gap={2}
                                                className="mt-5 mb-5 mx-auto text-center"
                                            >
                                                <Image
                                                    src={NoDraft}
                                                    width={88}
                                                    className="mx-auto"
                                                />
                                                <h4>{t('noDataAvailable')}</h4>
                                                <p>
                                                    {t("youHaven'tCreatedAny")}
                                                </p>
                                            </Stack>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                    {/* <Card.Footer>
                        <Stack direction="horizontal" gap={3}>
                            <div className="ms-auto">
                                <Stack direction="horizontal" gap={2}>
                                    <span>{pageCount} of {Math.ceil(patientData?.listData?.userProfileData?.length < patientListConfig.pageSize ? patientData?.listData?.userProfileData?.length : patientData.listData.totalItems / patientListConfig.pageSize)}</span>
                                    <Button variant='secondary' className='paginationBar_rightSide_prev' disabled={pageCount > 1 ? false : true} onClick={() => {
                                        handleFilterChange(pageCount - 1)
                                    }}>{t("prev")}</Button>
                                    <Button className='paginationBar_rightSide_next' disabled={pageCount !== Math.ceil(patientData.listData.totalItems / 50) ? false : true} onClick={() => {
                                        handleFilterChange(pageCount + 1)
                                    }}>{t("next")}</Button>
                                </Stack>
                            </div>
                        </Stack>
                    </Card.Footer> */}
                </Card>
            </Container>
        </>
    );
};

export default DoctorList;
